import { createFeatureSelector, createSelector } from '@ngrx/store';

import { AllowedOsUpdate, AllowedOsUpdateState } from './allowed-os-updates.state';
import * as fromAllowedOsUpdates from './allowed-os-updates.reducer';
import { allowedOsUpdateFeatureKey } from './allowed-os-updates.reducer';
import { DevicesRouterStoreSelectors } from '../../../../stores/router';
import { Dictionary } from '@ngrx/entity';

export const selectAllowedOsUpdatesState = createFeatureSelector<AllowedOsUpdateState>(allowedOsUpdateFeatureKey);

export const selectAllAllowedOsUpdates = createSelector(
  selectAllowedOsUpdatesState,
  fromAllowedOsUpdates.selectAllAllowedOsUpdates
);
export const selectAllAllowedOsUpdatesIds = createSelector(
  selectAllowedOsUpdatesState,
  fromAllowedOsUpdates.selectAllowedOsUpdateIds,
  (_, ids) => ids as string[]
);

export const selectAllAllowedOsUpdatesEntities = createSelector(
  selectAllowedOsUpdatesState,
  fromAllowedOsUpdates.selectAllowedOsUpdateEntities
);

export const selectAllowedOsUpdateIdsForCurrentDevice = createSelector(
  selectAllAllowedOsUpdatesIds,
  DevicesRouterStoreSelectors.selectUdid,
  (updates: string[], udid: string) => (updates ? updates.filter((x) => x.startsWith(udid)) : [])
);

export const selectIsCurrentDeviceAtLatestAllowedOsVersion = createSelector(
  selectAllAllowedOsUpdatesEntities,
  selectAllowedOsUpdateIdsForCurrentDevice,
  (updates: Dictionary<AllowedOsUpdate>, ids: string[]) => {
    const values: AllowedOsUpdate[] = [];
    for (const id of ids) {
      values.push(updates[id]);
    }
    return values.length === 0;
  }
);
